import { render } from "./TemplateManagement.vue?vue&type=template&id=5dc1d8e9&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"

import "./TemplateManagement.vue?vue&type=style&index=0&id=5dc1d8e9&scoped=true&lang=css"

import exportComponent from "/home/lyonjo5/lyon-marketing-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc1d8e9"]])

export default __exports__